"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KalturaAPIException = void 0;
var tslib_1 = require("tslib");
var KalturaAPIException = /** @class */ (function (_super) {
    tslib_1.__extends(KalturaAPIException, _super);
    function KalturaAPIException(message, code, args) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.code = code;
        _this.args = args;
        // Set the prototype explicitly.
        Object.setPrototypeOf(_this, KalturaAPIException.prototype);
        return _this;
    }
    return KalturaAPIException;
}(Error));
exports.KalturaAPIException = KalturaAPIException;

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwaS9rYWx0dXJhLWFwaS1leGNlcHRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBO0lBQXlDLCtDQUFLO0lBQzFDLDZCQUFtQixPQUFlLEVBQVMsSUFBWSxFQUFTLElBQVM7UUFBekUsWUFDSSxrQkFBTSxPQUFPLENBQUMsU0FJakI7UUFMa0IsYUFBTyxHQUFQLE9BQU8sQ0FBUTtRQUFTLFVBQUksR0FBSixJQUFJLENBQVE7UUFBUyxVQUFJLEdBQUosSUFBSSxDQUFLO1FBR3JFLGdDQUFnQztRQUNoQyxNQUFNLENBQUMsY0FBYyxDQUFDLEtBQUksRUFBRSxtQkFBbUIsQ0FBQyxTQUFTLENBQUMsQ0FBQzs7SUFDL0QsQ0FBQztJQUNMLDBCQUFDO0FBQUQsQ0FQQSxBQU9DLENBUHdDLEtBQUssR0FPN0M7QUFQWSxrREFBbUIiLCJmaWxlIjoiYXBpL2thbHR1cmEtYXBpLWV4Y2VwdGlvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBLYWx0dXJhQVBJRXhjZXB0aW9uIGV4dGVuZHMgRXJyb3Ige1xuICAgIGNvbnN0cnVjdG9yKHB1YmxpYyBtZXNzYWdlOiBzdHJpbmcsIHB1YmxpYyBjb2RlOiBzdHJpbmcsIHB1YmxpYyBhcmdzOiBhbnkpIHtcbiAgICAgICAgc3VwZXIobWVzc2FnZSk7XG5cbiAgICAgICAgLy8gU2V0IHRoZSBwcm90b3R5cGUgZXhwbGljaXRseS5cbiAgICAgICAgT2JqZWN0LnNldFByb3RvdHlwZU9mKHRoaXMsIEthbHR1cmFBUElFeGNlcHRpb24ucHJvdG90eXBlKTtcbiAgICB9XG59Il19
